// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1R9Bx","row":"ProcedureTreatmentSummary_row__2NuY-"};